import { Component, inject, Input, OnInit } from '@angular/core'
import { Table } from '@ui/Table'
import {
	CdkTableComponent,
	CdkTableFooter,
} from '@ui/Components/Table/CdkTable.Component'
import { NgStyle } from '@angular/common'
import Order from '@client/Order'
import OrderItem from '@client/OrderItem'
import { SystemConfigService } from '@client/Services/SystemConfigService'
import { formatCurrency } from '@ui/utils'

@Component({
	selector: 'guests-table-component',
	templateUrl: './OrderItems.Component.html',
	imports: [CdkTableComponent, NgStyle],
})
export class OrderItemsComponent extends Table<OrderItem> implements OnInit {
	@Input() protected readonly order: Order

	protected footer: CdkTableFooter<OrderItem>

	private readonly systemConfigService: SystemConfigService

	constructor() {
		super()
		this.systemConfigService = inject(SystemConfigService)
	}

	public ngOnInit() {
		this.displayColumns = ['name', 'unit_amount']

		this.tableEntities = [
			{
				columnDef: 'name',
				header: 'Name',
				accessorCallback(entity: OrderItem): string {
					return entity.guest.name
				},
			},
			{
				columnDef: 'unit_amount',
				header: 'Amount',
				type: 'currency',
				currency: {
					currency: this.order.currency,
					locale: this.systemConfigService.config.locale,
					currencyPrecision: this.order.currency_precision,
				},
				accessorKey: 'unit_amount',
			},
		]

		this.footer = {
			label: 'Total',
			value: formatCurrency(
				this.order.total,
				this.order.currency,
				this.systemConfigService.config.locale,
				this.order.currency_precision,
			),
		}

		this.setTableData(this.order.items)
	}
}
